
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.6518 3.88407C12.383 3.6038 12.0639 3.38146 11.7127 3.22977C11.3614 3.07808 10.985 3 10.6048 3C10.2246 3 9.84808 3.07808 9.49684 3.22977C9.14559 3.38146 8.82647 3.6038 8.55769 3.88407L7.99988 4.46547L7.44207 3.88407C6.89915 3.3182 6.1628 3.00029 5.395 3.00029C4.62721 3.00029 3.89085 3.3182 3.34794 3.88407C2.80502 4.44995 2.50002 5.21744 2.50002 6.0177C2.50002 6.81797 2.80502 7.58546 3.34794 8.15134L3.90575 8.73274L7.99988 13L12.094 8.73274L12.6518 8.15134C12.9207 7.87119 13.134 7.53857 13.2796 7.17247C13.4251 6.80638 13.5 6.41398 13.5 6.0177C13.5 5.62143 13.4251 5.22903 13.2796 4.86293C13.134 4.49684 12.9207 4.16422 12.6518 3.88407Z","fill":"#10001F","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    